function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // console.log(userAgent);
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent,
  );
}
export { isMobileDevice };
